type EventName =
  | "plan_started"
  | "surprise_plan_started"
  | "plan_generated"
  | "auth_started"
  | "auth_completed"
  | "plan_claimed"
  | "place_replaced"
  | "booking_requests_started"
  | "venue_booking_started"
  | "venue_booking_submitted"
  | "payment_action_opened"
  | "payment_server_confirmed"
  | "review_submitted"
  | "weather_refresh_requested";
type Properties = Record<string, string | number | boolean | undefined>;
export interface AnalyticsAdapter {
  track(name: EventName, properties?: Properties): void;
}
class ConsoleAnalytics implements AnalyticsAdapter {
  track(name: EventName, properties?: Properties) {
    if (import.meta.env.DEV)
      console.info("[analytics]", name, properties ?? {});
  }
}
let adapter: AnalyticsAdapter = new ConsoleAnalytics();
export const analytics = {
  track: (name: EventName, properties?: Properties) =>
    adapter.track(name, properties),
  configure: (next: AnalyticsAdapter) => {
    adapter = next;
  },
};
